import React from 'react';
import {CheckCircle2, Leaf, MapPin, Award} from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';

export default function About() {
  const { t } = useLanguage();
  
  return (
    <section id="about" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          
          {/* Image Grid */}
          <div className="relative">
            <div className="aspect-[4/3] rounded-2xl overflow-hidden shadow-2xl">
              <img
                src="https://static.lumi.new/5e/5ec2be053bab73e5f20226ee4033e9aa.jpeg"
                alt="Gestão florestal sustentável"
                className="w-full h-full object-cover hover:scale-105 transition-transform duration-700"></img>

            </div>
            <div className="absolute -bottom-8 -right-8 w-2/3 aspect-[4/3] rounded-2xl overflow-hidden shadow-2xl border-4 border-white hidden md:block">
              <img
                src="https://static.lumi.new/32/32b4f6a0d4558f08a5f08ffb4824bba8.jpeg"
                alt="Manutenção de espaços verdes"
                className="w-full h-full object-cover hover:scale-105 transition-transform duration-700"></img>

            </div>
            
            {/* Experience Badge */}
            



          </div>

          {/* Content */}
          <div className="lg:pl-8">
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-green-100 text-green-800 text-sm font-semibold mb-6">
              
              <span className="font-black text-base">{t('about.badge')}</span>
            </div>
            
            <h2 className="text-2xl sm:text-3xl md:text-4xl font-playfair font-bold text-gray-900 mb-6">
              {t('about.title')}
            </h2>
            
            <p className="text-base sm:text-lg text-gray-600 mb-6 leading-relaxed">
              {t('about.description1')}
            </p>
            
            <p className="text-base sm:text-lg text-gray-600 mb-8 leading-relaxed">
              {t('about.description2')}
            </p>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              {[
              { icon: MapPin, text: t('about.location') },
              { icon: Award, text: t('about.founded') },
              { icon: CheckCircle2, text: t('about.team') },
              { icon: Leaf, text: t('about.sustainability') }].
              map((item, idx) =>
              <div key={idx} className="flex items-center gap-3 p-3 rounded-lg bg-gray-50 hover:bg-green-50 transition-colors">
                  <item.icon className="h-5 w-5 text-green-700" />
                  <span className="font-medium text-gray-800">{item.text}</span>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </section>);

}